import { render, staticRenderFns } from "./F6.vue?vue&type=template&id=645ebfff&scoped=true"
import script from "./F6.vue?vue&type=script&lang=js"
export * from "./F6.vue?vue&type=script&lang=js"
import style0 from "./F6.vue?vue&type=style&index=0&id=645ebfff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ebfff",
  null
  
)

export default component.exports